import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import { Badge } from "@/components/ui/badge";
import type { Contract } from "@/lib/coach-manager/types";

interface ContractsTableProps {
  contracts: Contract[];
  onSelect: (contract: Contract) => void;
}

/**
 * The matrix list of matched Contracts — critical columns only. Clicking
 * anywhere in a row opens the detail drawer (`onSelect`) rather than
 * expanding inline (see the Round 2 redesign in the plan doc).
 */
export function ContractsTable({ contracts, onSelect }: ContractsTableProps) {
  return (
    <DataTable
      headers={[
        { label: "Contract ID" },
        { label: "Client ID" },
        { label: "Booking Type" },
        { label: "Operator ID" },
        { label: "Date Created" },
        { label: "Movements" },
        { label: "Status" },
      ]}
    >
      {contracts.map((contract) => (
        <tr
          key={contract.ContractID}
          className="cursor-pointer border-b last:border-b-0 hover:bg-muted/40"
          onClick={() => onSelect(contract)}
        >
          <td className="px-4 py-2">
            <span className="font-medium text-primary">{contract.ContractID}</span>
          </td>
          <td className="px-4 py-2">{formatCellValue(contract.ClientID)}</td>
          <td className="px-4 py-2">{formatCellValue(contract.BookingType)}</td>
          <td className="px-4 py-2">{formatCellValue(contract.OperatorID)}</td>
          <td className="px-4 py-2">{formatCellValue(contract.DateCreated)}</td>
          <td className="px-4 py-2">{contract.ContractMovements?.length ?? 0}</td>
          <td className="px-4 py-2">
            {contract.Cancelled ? (
              <Badge variant="destructive">Cancelled</Badge>
            ) : (
              <Badge variant="success">Active</Badge>
            )}
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
